import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Platform,
  ImageBackground,
} from "react-native";
import { Entypo } from "@expo/vector-icons";
import AppLoading from "expo-app-loading";
import { useFonts, Limelight_400Regular } from "@expo-google-fonts/limelight";
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useRef } from "react";
import { Animated, Easing } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
const Home = () => {
  const fadeAnimation = new Animated.Value(0);
  const loopAnim = useRef(new Animated.Value(0)).current;
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const nav = useNavigation();

  useEffect(() => {
    Animated.loop(
      Animated.timing(loopAnim, {
        toValue: 1,
        duration: 10500,
        useNativeDriver: false,
      })
    ).start();
  }, [loopAnim]);
  const rotateObject = loopAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360deg"],
  });
  useEffect(() => {
    Animated.loop(
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 2500,
        useNativeDriver: false,
      })
    ).start();
  }, [fadeAnim]);
  const fadeIn = fadeAnim.interpolate({
    inputRange: [0, 0.5,1],
    outputRange: [0, 1, 0],
  });


  const animatedObject = {
    transform: [{ rotate: rotateObject }],
  };
  const trans = {
    transform: [{ translateY: fadeAnimation }],
  };
  const spinValue = new Animated.Value(0);

  const spin = () => {
    spinValue.setValue(0);
    Animated.timing(spinValue, {
      toValue: 1,
      duration: 1500,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start(() => spin());
  };
  useEffect(() => {
    spin();
  }, []);

  const rotate = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "60deg"],
  });

  //  let [fontsLoaded] = useFonts({
  //   Limelight_400Regular,
  // });
  // if (!fontsLoaded) {
  //   return <AppLoading />;
  // }

  const tech = require("../../assets/pexels-junior-teixeira-2047905.jpg");

  const Contact = () => {
    nav.navigate("Contact");
  };

  const toggleVisible = () => {
    setVisible(!visible);
  };

  return (
    <View style={styles.container}>
      <ImageBackground source={tech} resizeMode="cover" style={styles.image}>
        <View style={styles.wrapper}>
          <Text style={styles.paragraph}>
            <Animated.View style={{ transform: [{ rotate }] }}>
              <Entypo name="hand" size={24} color="yellow" />
            </Animated.View>
            <Text style={styles.Hi}> I'm </Text>

            <Animated.View style={[styles.circle,animatedObject]}>
              <Text style={styles.circleText}>Eyobel </Text>
            </Animated.View>
          </Text>
          <Text style={styles.paragraph}>
            A talented and passionate Frontend web developer based in CA
          </Text>

          <TouchableOpacity onPress={Contact}>
            <Text style={styles.project}>Have a project?</Text>
          </TouchableOpacity>
        </View>
      </ImageBackground>
    </View>
  );
};
export default Home;
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#041e2a",
    height: "100%",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    alignSelf: "center",
    color: "#fff",
    // fontFamily: "Limelight_400Regular",
  },
  green: {
    fontSize: 35,
    fontWeight: "bold",
    marginBottom: 20,
    alignSelf: "center",
    color: "#08e008",
  },
  paragraph: {
    marginBottom: 20,
    marginLeft: 10,
    alignSelf: "center",
    marginTop: 15,
    color: "#fff",
    maxWidth: 800,
    // fontFamily: "Limelight_400Regular",
    fontSize: Platform.OS === "web" ? 18 : 15,
  },
  Hi: {
    fontSize: 30,
    // fontFamily: "Limelight_400Regular",
    color: "#F2D379",
  },
  project: {
    fontSize: 20,
    textAlign: "center",
    marginTop: Platform.OS === "web" ? 50 : 230,
    color: "#fff",
    backgroundColor: "green",
    padding: 10,
    borderRadius: 10,
  },
  wrapper: {
    alignItems: "center",
    marginTop: 40,
  },
  image: {
    flex: 1,

    width: "100%",
    height: "100%",
    opacity: 0.9,
  },

  circleText: {
    fontSize: 30,
    marginTop: 15,
    color: "green",
    fontWeight: Platform.OS === "web" ? "bold" : null,
  },
});
